import Modal from "react-bootstrap/Modal";
import { Form, FormControl, Button, Alert } from "react-bootstrap";
import { useState } from "react";
import Cookies from "js-cookie";
import axios from "axios";

function InviteModal({ show, onHide, challenge_oid }) {
  const [invitee, setInvitee] = useState("");
  const [showErrorAlert, setErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [alertInvitee, setAlertInvitee] = useState();

  const handleChange = (event) => {
    // Allows no spaces
    const newValue = event.target.value.replace(/\s/g, "");
    setInvitee(newValue);
  };

  const handleSearch = () => {
    setAlertInvitee(invitee);

    if (invitee === "") {
      // Ensure that field is not empty
      return;
    }

    const authToken = Cookies.get("authToken");
    const headers = {
      Authorization: `Bearer ${authToken}`,
      "Content-Type": "application/json",
    };
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/challenges/invitation`,
        { recipient_user: `${invitee}`, challenge_oid: challenge_oid },
        { headers: headers }
      )
      .then((response) => {
        setErrorAlert(false);
        setShowSuccessAlert(true);
        setInvitee("");
      })
      .catch((error) => {
        setErrorMessage(error.response.data);
        setErrorAlert(true);
        setInvitee("");
      });
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Invitations</Modal.Title>
      </Modal.Header>

      <Form></Form>
      <FormControl
        type="search"
        placeholder="Enter username (e.g. username21)"
        onChange={handleChange}
        value={invitee}
        pattern="^/S*$"
      ></FormControl>
      <br></br>
      <Button variant="outline-secondary" onClick={handleSearch}>
        Invite
      </Button>
      <div>
        {showSuccessAlert && (
          <Alert variant="success">Invitation sent for {alertInvitee}</Alert>
        )}
        {showErrorAlert && <Alert variant="danger">{errorMessage}</Alert>}
      </div>
    </Modal>
  );
}

export default InviteModal;
